export const BASE_NOTICE_PATH = '/notices';

export const INDEX_NOTICE_PATH = `${ BASE_NOTICE_PATH }/all`;
